import {TableCell, TableCellProps} from "@mui/material";

export function StyledTableCell(props: TableCellProps) {
    return (
      <TableCell
        {...props}
        sx={{
            '&.MuiTableCell-head': {backgroundColor: 'common.black', color: 'common.white', fontSize: 16, position: 'relative'},
            '&.MuiTableCell-body': {fontSize: 16},
            ...(props.sx || {}),
        }}
      />
    )
};
